import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rawPrice'
})
export class RawPricePipe implements PipeTransform {
  transform(value: string): number {
    const match = value.match(/[\d,.]+/);
    return match ? parseFloat(match[0].replace(',', '.'))*13 : 0;
  }
}
